// @ts-check
import required from 'utils/required';

import { RECEIVE_REFERRAL_QUESTIONNAIRE } from 'agent_portal/actions/ReferralProfiles/QuestionnaireActions';

const initialState = {
  referralQuestionnaire: null,
  patientName: null,
  referralProfile: null,
  rulableReferralProfileValues: null,
};

const reducer = (state = initialState, action) => {
  // TODO: `actions.savingReferralQuestionnaire()` etc. don't currently do anything
  switch (action.type) {
    case RECEIVE_REFERRAL_QUESTIONNAIRE:
      const {
        referralQuestionnaire = required('referralQuestionnaire'),
        patientName = required('patientName'),
        referralProfile = required('referralProfile'),
        rulableReferralProfileValues = required('rulableReferralProfileValues'),
      } = action.payload;
      return {
        ...state,
        referralQuestionnaire,
        patientName,
        referralProfile,
        rulableReferralProfileValues,
      };
    default:
      return state;
  }
};

export default reducer;
